<template>
  <div class="packages-card">
    <div class="title">{{ title }}</div>
    <div class="price">{{ price }} Р</div>
    <div class="date">{{ $moment(date, 'MM.DD.YYYY').format('DD.MM.YYYY') }}</div>
    <p class="address">{{ address }}</p>
    <div class="status" v-if="status">Запись подтверждена</div>
    <div class="status danger" v-else>Запись не подтверждена</div>
    <div class="master">
      <img :src="avatar" alt="">
      <div class="item">
        <div class="name">{{ name }}</div>
        <div class="number">{{ number }}</div>
      </div>
      <button v-if="id" @click="createConversation(id)">Чат</button>
    </div>
  </div>
</template>

<script>
import ChatMixin from "@/mixins/chat";

export default {
  name: 'record-card',
  props: {
    id: [String, Number],
    title: String,
    price: [String, Number],
    date: String,
    address: String,
    status: Boolean,
    avatar: String,
    name: String,
    number: String,
  },
  mixins: [
    ChatMixin
  ],
  mounted() {
    console.log(this.$moment('10.21.2020', 'MM.DD.YYYY').format('DD.MM.YYYY'))
  }
}
</script>

<style scoped lang="scss">
.packages-card {
  position: relative;
  padding: 15px 20px;
  border: 1px solid #DBBFA7;
  border-radius: 10px;
  background-color: #FFFFFF;
}

.title {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  color: #383838;
  margin-bottom: 5px;
}

.price {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #383838;
  margin-bottom: 5px;
}

.date {
  font-size: 14px;
  line-height: 1.71;
  color: #808080;
}

.address {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #808080;
}

.status {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #0F8A84;
  padding: 15px 0;
  border-bottom: 1px solid #DBBFA7;
}

.master {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 100%;

  img {
    height: 50px;
    width: 50px;
    border-radius: 50px;
    object-fit: cover;
  }

  .item {
    margin-left: 10px;

    .name {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #383838;
    }

    .number {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      color: #808080;
    }
  }

  button {
    border: 1px solid #DBBFA7;
    border-radius: 5px;
    background: initial;
    height: 50px;
    width: 70px;
    margin-left: auto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #383838;
  }
}

.danger {
  color: #E05252 !important;
}

@media screen and (max-width: 768px) {
  .master {
    flex-wrap: wrap;
    align-items: flex-start;

    button {
      margin-top: 15px;
      margin-left: 0;
      width: 100%;
    }
  }
}
</style>
